import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Slider, Arrow, SanitizeHTML } from '@tc-packages/tc-common'

export default function IconsSection({ section }) {
  const {
    config: { is_gray, show_arrows = true },
    items,
    node_id,
  } = section

  const [initialSlides, setInitialSlides] = useState(4)

  useEffect(() => {
    const updateSlidesToShow = () => {
      let currentSlides = 4

      if (window.matchMedia('(max-width: 991px)').matches) {
        currentSlides = 3
      }
      if (window.matchMedia('(max-width: 767px)').matches) {
        currentSlides = 1
      }

      setInitialSlides(currentSlides)
    }

    updateSlidesToShow()
    window.addEventListener('resize', updateSlidesToShow)
    return () => window.removeEventListener('resize', updateSlidesToShow)
  }, [])

  const carouselControlsButtonStyles = {
    '--button-carousel-controls-background': '#1b8158',
    '--button-carousel-controls-background-hover': '#055f30',
    '--button-carousel-controls-color': '#ffffff',
    '--button-carousel-controls-color-hover': '#ffffff',
  }

  const carouselSettings = {
    slidesToScroll: 1,
    slidesToShow: initialSlides,
    infinite: false,
    nextArrow: (
      <Arrow
        carouselControlsButtonStyles={carouselControlsButtonStyles}
        direction="next"
      />
    ),
    prevArrow: (
      <Arrow
        carouselControlsButtonStyles={carouselControlsButtonStyles}
        direction="prev"
      />
    ),
    className: [
      'simpleCards_row',
      'row',
      show_arrows && 'simpleCardsIcon_withArrows',
      `iconCards_slider_${node_id}`,
    ]
      .filter(Boolean)
      .join(' '),
  }

  const sliderItem = (item) => {
    return (
      <div className="simpleCardsIcon_item col-md-3" key={item.index}>
        <div className="simpleCardsIcon_content">
          <img
            alt={item.alt}
            className="simpleCardsIcon_icon"
            src={item.icon}
          />
          {item.title && (
            <h3 className="simpleCardsIcon_title">{item.title}</h3>
          )}
          <div className="simpleCardsIcon_text">
            <SanitizeHTML
              className="simpleCardsIcon_textContent"
              html={item.content}
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <section className={is_gray ? 'section--grey' : ''} key={node_id}>
      <div className="container contentWrapper_large">
        {items.length > initialSlides ? (
          <Slider
            items={items.map((item) => sliderItem(item))}
            {...carouselSettings}
          />
        ) : (
          <div
            className={[
              'simpleCards_row',
              'row',
              show_arrows && 'simpleCardsIcon_withArrows',
              'iconCards_slider_static',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {items.map((item) => sliderItem(item))}
          </div>
        )}
      </div>
    </section>
  )
}

IconsSection.propTypes = {
  section: PropTypes.shape({
    config: PropTypes.shape({
      is_gray: PropTypes.bool.isRequired,
      show_arrows: PropTypes.bool,
    }).isRequired,
    items: PropTypes.array.isRequired,
    node_id: PropTypes.string.isRequired,
  }).isRequired,
}
